import SectionHeading from '@/components/feature/SectionHeading';
import { testimonials } from '@/mocks/site';

export default function TestimonialSection() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="Readers"
          title="追剧的人怎么说"
          desc="来自日常追剧观众的反馈，也是我们持续修订更新顺序与分集介绍的理由。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {testimonials.map((item) => (
            <figure key={item.name} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <i className="ri-double-quotes-l text-2xl text-accent-400" aria-hidden="true" />
              <blockquote className="mt-3 flex-1 text-sm leading-7 text-foreground-700">{item.text}</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="h-11 w-11 overflow-hidden rounded-full bg-background-200">
                  <img src={item.avatar} alt={`${item.name}的头像`} title={item.name} className="h-full w-full object-top" />
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}